import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, Tooltip, makeStyles } from '@material-ui/core';
import { IconButton, Typography } from 'components';
import UserPhoto from 'views/common/UserPhoto';

const EmployeeRowItem = ({
  data,
  minimize = false,
  onClick,
  onHistoryClick = null,
  onLeaveHistoryClick = null,
}) => {
  const classes = useStyles();
  const app = useSelector((state) => state.app);

  return (
    <Grid container style={{ paddingLeft: 4 }}>
      {/* <Grid item xs={1} className={classes.grid}>
				<Typography variant='body1'>{index + 1}</Typography>
			</Grid> */}
      <Grid
        item
        xs={minimize ? 11 : app.env.needUpperSupervisorApproval ? 3 : 4}
        style={{ display: 'flex', alignItems: 'center', whiteSpace: 'wrap' }}
      >
        <UserPhoto nip={data.nip} size={'md'} />
        <div style={{ marginLeft: 16 }}>
          <Typography variant="body1" type="bold">
            {app.env.projectId === 'atmost-hasto' &&
              (data.employmentStatus === 'PNS' ? 'PNS' : data.employmentType || '') + ' '}
            {data.fullname}
          </Typography>
          <Typography variant="body1" color="#8DA1AB">
            {data.nip}
          </Typography>
          <Grid style={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="body1" color="#8DA1AB">
              {data.employeeNo}
            </Typography>
            {data.isHR && (
              <div className={classes.chipHr}>
                <Typography variant="caption" color="#FBB327">
                  HR
                </Typography>
              </div>
            )}
            {data.isDoctor && (
              <div className={classes.chipDoctor}>
                <Typography variant="caption" color="#01C58A">
                  Dokter
                </Typography>
              </div>
            )}
            {!data.isActive && (
              <div className={classes.chipResign}>
                <Typography
                  variant="caption"
                  style={{ fontWeight: 'bold', marginRight: 4 }}
                  color="#EF4040"
                >
                  X
                </Typography>
                <Typography variant="caption" color="#EF4040">
                  Resign
                </Typography>
              </div>
            )}
            {data.isTest && (
              <div className={classes.chipTester}>
                <Typography variant="caption" color="#4956CF">
                  Tester
                </Typography>
              </div>
            )}
          </Grid>
        </div>
      </Grid>
      {!minimize && (
        <>
          <Grid item xs={3} className={classes.grid}>
            <Typography variant="body1" type="bold">
              {data.division}
            </Typography>
            <Typography variant="body1" color="#8DA1AB">
              {data.position}
            </Typography>
          </Grid>
          <Grid item xs={2} className={classes.grid}>
            <Typography variant="body1" type="bold">
              {data.phoneNo || '-'}
            </Typography>
            <Typography variant="body1" color="#8DA1AB">
              {app.env.usePrivateMail ? data.email : data.privateEmail || '-'}
            </Typography>
          </Grid>
          <Grid item xs={app.env.needUpperSupervisorApproval ? 3 : 2} className={classes.grid}>
            <Typography variant="body1" type="bold">
              {data.superiorName || '-'}
            </Typography>
            {app.env.needUpperSupervisorApproval && (
              <Typography variant="body1" type="bold">
                {data.upperSuperiorName || '-'}
              </Typography>
            )}
          </Grid>
        </>
      )}
      <Grid
        item
        xs={1}
        className={classes.grid}
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          gap: 6,
        }}
      >
        {onHistoryClick && (
          <Tooltip placement="top" title="Riwayat Kehadiran" arrow>
            <IconButton icon="list" color="#A5B3BA" onClick={onHistoryClick} />
          </Tooltip>
        )}
        {onLeaveHistoryClick && (
          <Tooltip placement="top" title="Informasi Cuti Pegawai" arrow>
            <IconButton icon="calendar" color="#A5B3BA" onClick={onLeaveHistoryClick} />
          </Tooltip>
        )}
        {onClick && (
          <Tooltip placement="top" title="Data Pegawai" arrow>
            <IconButton icon="chevron-right" color="#A5B3BA" onClick={onClick} />
          </Tooltip>
        )}
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  grid: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    whiteSpace: 'wrap',
  },
  chipResign: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 18,
    borderRadius: 24,
    paddingRight: 8,
    paddingLeft: 8,
    marginLeft: 4,
    backgroundColor: '#FFD6D6',
  },
  chipHr: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 18,
    borderRadius: 24,
    paddingRight: 8,
    paddingLeft: 8,
    marginLeft: 4,
    backgroundColor: '#FFEFCE',
  },
  chipDoctor: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 18,
    borderRadius: 24,
    paddingRight: 8,
    paddingLeft: 8,
    marginLeft: 4,
    backgroundColor: 'rgba(1, 197, 138, 0.12)',
  },
  chipTester: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 18,
    borderRadius: 24,
    paddingRight: 8,
    paddingLeft: 8,
    marginLeft: 4,
    backgroundColor: 'rgba(73, 86, 207, 0.12)',
  },
}));

export default EmployeeRowItem;
